import { Injectable } from '@angular/core';
import { Product, Variant } from '../components/hof/product/product.component';
import { BlockNode } from '../types/rich-text.types';

@Injectable({
    providedIn: 'root',
})
export class ProductService {
    getVariantLabel(product: Product, variant: Variant) {
        if (product.inventoryType === 'weight') {
            return `${variant.weight} ${variant.label}`;
        }
        return variant.label;
    }

    isFullySoldOut(product: Product) {
        return product.variants.every((variant) => variant.amount === 0);
    }

    getPreviewText(blockNodes: BlockNode[]): string {
        return (
            blockNodes
                .filter((node) => node.type === 'paragraph')
                .flatMap((node) =>
                    node.children
                        .filter((child) => child.type === 'text')
                        .filter((child) => child.text !== '')
                        .map((child) =>
                            child.text
                                .trim()
                                .replace('<g>', '')
                                .replace('<c>', ''),
                        ),
                )
                .join(' ')
                .split(' ')
                .slice(0, 25)
                .join(' ') + '...'
        );
    }

    getJsonLd(product: Product) {
        return {
            '@context': 'https://schema.org/',
            '@type': 'Product',
            name: product.name,
            image: product.images?.map((image) => image.url),
            description: this.getPreviewText(product.description),
            sku: product.variants[0].uuid,
            offers: {
                '@type': 'Offer',
                priceCurrency: 'EUR',
                price: product.price,
                availability: this.isFullySoldOut(product)
                    ? 'https://schema.org/OutOfStock'
                    : 'https://schema.org/InStock',
                url: window.location.href,
                shippingDetails: [
                    {
                        '@type': 'OfferShippingDetails',
                        shippingRate: {
                            '@type': 'MonetaryAmount',
                            value: 18,
                            currency: 'EUR',
                        },
                        shippingDestination: {
                            '@type': 'DefinedRegion',
                            name: 'Kühlversand',
                            addressCountry: 'AT',
                        },
                    },
                    {
                        '@type': 'OfferShippingDetails',
                        shippingRate: {
                            '@type': 'MonetaryAmount',
                            value: 0,
                            currency: 'EUR',
                        },
                        shippingDestination: {
                            '@type': 'DefinedRegion',
                            name: 'Abholung am Hof',
                            addressCountry: 'AT',
                        },
                    },
                ],
            },
        };
    }
}
